<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (location of locations | async; track trackBy(location)) {
      <lcs-option [value]="location" id="lcs-option-id-{{ location.locationId }}">
         {{ location.name ? location.name + ' - ' : '' }}{{ location | ndtStreet }}
      </lcs-option>
      }
   </div>
</ng-template>
